import React, { useEffect } from 'react';
import { formatCurrency } from '../../../utils/helpers';
import Loader from '../../general/Loader';
import Modal from '../../general/Modal';
import FormBecas from './Forms/FormBecas';
import { useConfiguracionAcademica } from './ConfiguracionAcademicaContext';

const Becas = () => {
    const {items, item, onFiltroChange, toggleCreateModal, toggleEditModal, toggleDeleteModal, filtrosQuery, loading, errors, getData, create, edit, deleteItem, clasesEstadoMapping, saving, showEdit, showDelete, showCreate} = useConfiguracionAcademica();

    const url = "academico/becas";
    useEffect(() => {
        getData(`${url}${filtrosQuery}`);
    }, [filtrosQuery]);

    return (<>
        <div className="row m-b-20 descripcion-subpage">
            <div className="col">
                <input
                    type="text"
                    className='form-control'
                    name="buscar"
                    onChange={(e) =>
                        onFiltroChange(e.target.value, "buscar")
                    }
                    placeholder='Buscar...'
                />
            </div>
            <div className="col-md-3 text-right">
                <button className="au-btn au-btn-icon au-btn--green au-btn--small" onClick={() => toggleCreateModal()}>+ Nueva Beca</button>
            </div>
        </div>
        <hr />
        {loading && <Loader />}
        {!loading && items.length > 0 && (<div className="table-data">
            <table className='table table-data2'>
                <thead>
                    <tr>
                        <th>Beca</th>
                        <th>Patrocinador</th>
                        <th className='text-center'>Monto</th>
                        <th className='text-center'>Porcentaje</th>
                        <th className='text-center'>Estado</th>
                        <th className='text-right'></th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item => (
                        <tr key={item.id} className="tr-shadow">
                            <td>{item.nombre}</td>
                            <td>{item.contacto?.nombre}</td>
                            <td className='text-center'>{formatCurrency(item.monto)}</td>
                            <td className='text-center'>{item.porcentaje}%</td>
                            <td className='text-center'>
                                <span className={`badge badge-${clasesEstadoMapping[item.estado]} text-uppercase`}>{item.estado}</span>
                            </td>
                            <td className='text-right'>
                                <div className="table-data-feature">
                                    <button
                                        className="item"
                                        onClick={() => toggleEditModal(item)}
                                    >
                                        <i className="zmdi zmdi-edit" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    )))}
                </tbody>
            </table>
        </div>)}

        {!loading && items.length === 0 && (
            <div className='text-center p-t-20 p-b-40'>{ filtrosQuery !== '?' ? "No hay elementos que coincidan con la búsqueda." : "No hay elementos creados." }</div>
        )}

        <Modal
            blank
            show={showCreate}
            toggle={() => toggleCreateModal()}>
            <form method='post' onSubmit={e => create(e, url, "Beca creada.") }>
                <input type="hidden" name="_method" value="POST" />
                <div className='popup__header'>Crear Nueva Beca</div>
                <div className='popup__body'>
                    <FormBecas
                        item={{}}
                        errors={errors}
                    />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={() => toggleCreateModal()}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {saving ? (<Loader type="small" />) : (<button type='submit' className='btn btn-primary'>
                        Crear
                    </button>)}
                </div>
            </form>
        </Modal>
        <Modal
            blank
            show={showEdit}
            toggle={toggleEditModal}>
            <form method='post' onSubmit={e => edit(e, url, "Beca actualizada.") }>
                <input type="hidden" name="_method" value="PATCH" />
                <div className='popup__header'>Editar Beca</div>
                <div className='popup__body'>
                    <FormBecas
                        item={item}
                        errors={errors}
                    />
                </div>
                <div className='popup__footer'>
                    {!saving && (
                    <button
                        type='button'
                        className='btn float-left'
                        onClick={toggleDeleteModal}>
                        <i className='fas fa-trash-alt'></i>
                    </button>)}
                    <button
                        type='button'
                        onClick={() => toggleEditModal()}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {saving ? (<Loader type="small" />) : (<button type='submit' className='btn btn-primary'>
                        Actualizar
                    </button>)}
                </div>
            </form>
        </Modal>
        <Modal
            title='Borrar Beca'
            show={showDelete}
            callback={() => deleteItem(url, "Beca borrada.")}
            acceptText="Borrar"
            toggle={toggleDeleteModal}>
            ¿Seguro que deseas borrar {item.nombre}?
        </Modal>
    </>)
}

export default Becas;
